import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { Accordion } from '../../common/Accordion'
import { AccordionItem } from '../../common/AccordionItem'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { HouseRuleContent } from './HouseRuleContent'
import { houseRuleQueries } from '../../../api/house-rules'

export const HouseRules = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  const { data: rules } = useQuery(
    houseRuleQueries.getHouseRulesPerSociety(society?._id)
  )

  return (
    <div className="w-full">
      {rules && rules.length > 0 ? (
        <Accordion hasBorder className="w-full md:max-w-screen-sm">
          {rules?.map((item, i) => (
            <AccordionItem
              className={`${i !== 0 ? 'border-t' : ''} p-5`}
              key={item._id}
              index={i}
              hasBorder
            >
              {{
                header: <div>{item.section}</div>,
                content: <HouseRuleContent houseRule={item} />,
              }}
            </AccordionItem>
          ))}
        </Accordion>
      ) : (
        <div>{translate('houseRulesView.noHouseRulesText')}</div>
      )}
    </div>
  )
}
